<script setup lang="ts">
const systemStore = useSystemStore()
</script>

<template>
  <v-dialog v-model="systemStore.dialog.isVisible" max-width="500" persistent>
    <v-card
      variant="flat"
      color="white"
      class="mx-auto"
      max-width="500"
      rounded="xl"
    >
      <v-card-title class="d-flex align-center font-weight-bold text-black px-12 pt-8">
        <v-icon
          v-if="systemStore.dialog.icon"
          :icon="systemStore.dialog.icon"
          :color="(systemStore.dialog.color === 'success' || systemStore.dialog.color === 'info') ? 'yellow-darken-2' : systemStore.dialog.color === 'error' ? 'c2' : systemStore.dialog.color"
          class="mr-2"
        />
        {{ systemStore.dialog.title }}
      </v-card-title>

      <v-card-text class="text-body-1 text-black px-12 py-8 pt-2" style="white-space: pre-line;">
        {{ systemStore.dialog.message }}
      </v-card-text>

      <v-card-actions class="px-12 pb-8 pt-0 justify-center">
        <v-btn
          text="확인"
          variant="flat"
          color="black"
          class="text-white px-8"
          rounded="xl"
          size="large"
          @click="systemStore.hideDialog"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
